import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_timer = _resolveComponent("timer");
  const _component_exam_quiz_score = _resolveComponent("exam-quiz-score");
  const _component_exam_quiz_results = _resolveComponent("exam-quiz-results");
  const _component_quiz_preamble = _resolveComponent("quiz-preamble");
  const _component_slide = _resolveComponent("slide");
  const _component_exam_quiz = _resolveComponent("exam-quiz");
  const _component_quiz_viewer_carousel = _resolveComponent("quiz-viewer-carousel");
  const _component_information_dialog = _resolveComponent("information-dialog");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_quiz_viewer_layout = _resolveComponent("quiz-viewer-layout");
  return _ctx.quiz && _ctx.examQuizUserRealtimeData ? (_openBlock(), _createBlock(_component_quiz_viewer_layout, {
    key: _ctx.layoutKey,
    "center-content": _ctx.examQuizStep === 'COMPLETED'
  }, _createSlots({
    content: _withCtx(() => [_ctx.examQuizStep === _ctx.ExamQuizPlayerStep.COMPLETED ? (_openBlock(), _createBlock(_component_exam_quiz_score, {
      key: 0,
      "is-scorm": _ctx.isScorm,
      "success-rate": _ctx.examQuizUserRealtimeData.successRate,
      "score-to-continue": _ctx.quiz.scoreToContinue,
      "remaining-tries": _ctx.examQuizUserRealtimeData.remaningTries,
      "can-edit": _ctx.canEdit,
      "is-speach-template": _ctx.isSpeachTemplate
    }, null, 8, ["is-scorm", "success-rate", "score-to-continue", "remaining-tries", "can-edit", "is-speach-template"])) : _createCommentVNode("", true), _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.TERMINATED ? (_openBlock(), _createBlock(_component_exam_quiz_results, {
      key: 1,
      "chapter-title": _ctx.chapterTitle,
      questions: _ctx.quiz.questions,
      "user-answers": _ctx.examQuizUserRealtimeData.overallAnswers,
      "success-rate": _ctx.examQuizUserRealtimeData.successRate,
      "can-edit": _ctx.canEdit,
      "is-speach-template": _ctx.isSpeachTemplate,
      "hide-answers": !_ctx.isScorm && _ctx.quiz.hideAnswers
    }, null, 8, ["chapter-title", "questions", "user-answers", "success-rate", "can-edit", "is-speach-template", "hide-answers"])) : _createCommentVNode("", true), _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.PREAMBLE || _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.STARTED ? (_openBlock(), _createBlock(_component_quiz_viewer_carousel, {
      key: 2,
      ref: "examQuizViewerCarousel",
      onSlideEnd: _ctx.onSlideChange
    }, {
      slides: _withCtx(() => [_createVNode(_component_slide, {
        key: "0"
      }, {
        default: _withCtx(() => [_ctx.examQuizStep === _ctx.ExamQuizPlayerStep.PREAMBLE ? (_openBlock(), _createBlock(_component_quiz_preamble, {
          key: 0,
          icon: "certificate-outline",
          title: _ctx.$t('view.speach.examQuiz.start.title'),
          items: _ctx.preambleItems,
          "can-edit": _ctx.canEdit,
          "is-speach-template": _ctx.isSpeachTemplate
        }, null, 8, ["title", "items", "can-edit", "is-speach-template"])) : _createCommentVNode("", true)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayableQuestions, (question, index) => {
        return _openBlock(), _createBlock(_component_slide, {
          key: index + 1
        }, {
          default: _withCtx(() => [_createVNode(_component_exam_quiz, {
            question: question,
            "quiz-nb-questions": _ctx.displayableQuestions.length,
            onAnswerChange: _ctx.onQuizAnswerChange
          }, null, 8, ["question", "quiz-nb-questions", "onAnswerChange"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["onSlideEnd"])) : _createCommentVNode("", true), _createVNode(_component_information_dialog, {
      visible: _ctx.examQuizUserRealtimeData.timeElapsed,
      width: "600px",
      title: _ctx.$t('view.speach.examQuiz.timeOverDialog.title'),
      message: _ctx.$t('view.speach.examQuiz.timeOverDialog.message')
    }, null, 8, ["visible", "title", "message"])]),
    _: 2
  }, [_ctx.timer && (_ctx.examQuizStep === _ctx.ExamQuizPlayerStep.PREAMBLE || _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.STARTED) ? {
    name: "timer",
    fn: _withCtx(() => [_createVNode(_component_timer, {
      ref: "timerComponent",
      timer: _ctx.remainingSeconds,
      onCountdownEnd: _ctx.countdownEnd,
      class: "timer"
    }, null, 8, ["timer", "onCountdownEnd"])]),
    key: "0"
  } : undefined, _ctx.examQuizStep !== _ctx.ExamQuizPlayerStep.TERMINATED && !(_ctx.isScorm && _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.COMPLETED) ? {
    name: "footer",
    fn: _withCtx(() => [_ctx.shouldDisplayRestartButton ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 0,
      class: "footer-button",
      outlined: _ctx.userHasWinningRate,
      label: _ctx.userHasWinningRate ? _ctx.$t('view.speach.examQuiz.restartButton') : _ctx.$t('view.speach.examQuiz.restartButtonLong'),
      onAction: _ctx.onRestartButtonClick
    }, null, 8, ["outlined", "label", "onAction"])) : _createCommentVNode("", true), _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.PREAMBLE ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 1,
      class: "footer-button",
      label: _ctx.$t('view.speach.examQuiz.startButton'),
      onAction: _cache[0] || (_cache[0] = $event => _ctx.onNextButtonClick())
    }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.examQuizStep === _ctx.ExamQuizPlayerStep.STARTED ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 2,
      class: "footer-button",
      disabled: !_ctx.userHasAnswered || _ctx.isSavingResults,
      label: _ctx.$t('view.speach.examQuiz.confirmButton'),
      onAction: _cache[1] || (_cache[1] = $event => _ctx.onNextButtonClick())
    }, null, 8, ["disabled", "label"])) : _createCommentVNode("", true), _ctx.shouldDisplayTerminateButton ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 3,
      class: "footer-button",
      label: _ctx.$t('view.speach.examQuiz.terminateButton'),
      onAction: _ctx.onQuizTerminateButtonClick
    }, null, 8, ["label", "onAction"])) : _createCommentVNode("", true)]),
    key: "1"
  } : undefined]), 1032, ["center-content"])) : _createCommentVNode("", true);
}